<template>
  <v-col cols="12" class="pa-0 pl-5 pr-5">
    <v-sheet rounded="lg">
      <v-container fluid>
        <h1 id="dadosLoja">Login</h1>
        <paragrafo
          >Realize o login com os dados recebidos por e-mail,
          preenchendo:</paragrafo
        >
        <li>Tipo de Usuário (Admin Lojista);</li>
        <li>Número da loja;</li>
        <li>Usuário;</li>
        <li>
          Senha (Necessário alterar após o primeiro acesso, veja instrução a
          seguir)
        </li>
        <imagem :src="image_1" />
        <paragrafo
          >Faça o login e
          <negrito>imediatamente altere a senha</negrito> informada no e-mail
          clicando no ícone sinalizado abaixo e em "Alterar Senha" (A senha do
          App Validator também será atualizada, ambos utilizam a
          mesma).</paragrafo
        >
        <imagem :src="image_2" />
        <paragrafo></paragrafo>
        <h1>Resumo</h1>
        <paragrafo
          >Após a alteração da senha e realização do login, aparecerá a tela
          abaixo. Que irá apresentar os dados dos eventos/produtos ativos e
          encerrados.</paragrafo
        >
        <paragrafo
          >O card correspondente a cada evento ou produto, apresenta informações
          como descrição do evento, data e horário, além do percentual de vendas
          alcançado.</paragrafo
        >
        <imagem :src="image_3" />
        <paragrafo
          >Ao selecionar um produto, a tela apresentada revelará dados
          detalhados das vendas: Total de vendas, Vendidos Hoje, Cortesias,
          Ingressos Disponíveis, Ticket Médio, Faturamento Total.</paragrafo
        >
        <imagem :src="image_4" />
        <paragrafo></paragrafo>
        <h1>Resumo Mobile</h1>
        <paragrafo
          >O resumo pode ser acessado no mobile, apresentando as informações de
          descrição do evento, data e horário, além do percentual de vendas
          alcançado, conforme é apresentado na versão desktop</paragrafo
        >
        <v-row justify="center">
          <imagem :src="image_5" className="imagem_mobile1" />
        </v-row>
        <paragrafo
          >Ao selecionar um produto, a tela apresentada revelará dados
          detalhados das vendas: Total de vendas, Vendidos Hoje, Cortesias,
          Ingressos Disponíveis, Ticket Médio, Faturamento Total.</paragrafo
        >
        <v-row justify="center">
          <imagem :src="image_6" className="imagem_mobile2" />
        </v-row>
        <v-row justify="center">
          <paragrafo>(Dados do dashboard meramente ilustrativos)</paragrafo>
        </v-row>
      </v-container>
    </v-sheet>
  </v-col>
</template>
<script>
export default {
  name: "Dashboard",
  components: {
    paragrafo: () => import("@/docs/components/infos/paragrafo.vue"),
    imagem: () => import("@/docs/components/infos/imagem.vue"),
    negrito: () => import("@/docs/components/infos/negrito.vue"),
  },
  data() {
    return {
      image_1: "/documentacao/dashboard/telalogin1.png",
      image_2: "/documentacao/dashboard/loginredsenha2.png",
      image_3: "/documentacao/dashboard/resumo1.png",
      image_4: "/documentacao/dashboard/resumo2.png",
      image_5: "/documentacao/dashboard/resumo3.png",
      image_6: "/documentacao/dashboard/resumo4.png",
    };
  },
};
</script>
